import * as ko from "knockout";
import Bao from "./../../services/bao-service";
import BaoMenu from "./../../services/bao-menu";
import BaseViewModel from "./../../factories/base-view-model";
import BaoDialog from "./../../factories/bao-dialog";
function EvaluationConflict(tabPage) {
    var self = this;
    self.Bao = Bao;
    BaseViewModel.call(this, tabPage);
    self.EvaluationId = ko.observable();
    self.PageIndex = ko.observable(0);
    self.PageIndex.subscribe(function (index) {
        self.Refresh();
    });
    self.PageSize = ko.observable(20);
    self.TotalRows = ko.observable(0);
    self.Sorting = ko.observableArray();
    self.Sorting.subscribe(function (sort) {
        self.Refresh();
    });
    self.EvaluationConflictId = ko.observable();
    self.ConflictPageIndex = ko.observable(0);
    self.ConflictPageIndex.subscribe(function () { });
    self.ConflictPageSize = ko.observable(20);
    self.ConflictTotalRows = ko.observable(0);
    self.ConflictSorting = ko.observableArray();
    self.ConflictSorting.subscribe(function () {
        self.GetAllEvaluationConflictsFromEvaluation(self.SelectedEvaluationRow().EvaluationId);
    });
    var ServerVersion = new Object();
    ServerVersion = {
        "EvaluationConflictId": null,
        "SyncDateHtml": "",
        "UpdateBy": "Serverversion verwenden",
        "UpdateDateHtml": "",
        "ClosedBy": "",
        "CompleteDateHtml": ""
    };
    self.EvaluationCollection = ko.observableArray([]);
    self.SelectEvaluationRow = function (item) {
        self.EvaluationConflictsFromSelectedEvaluation([]);
        self.SelectedEvaluationRow(item);
        return true;
    };
    self.SelectedEvaluationRow = ko.observable();
    self.SelectedEvaluationRow.subscribe(function () {
        if (self.SelectedEvaluationRow() != null) {
            self.GetAllEvaluationConflictsFromEvaluation(self.SelectedEvaluationRow().EvaluationId);
        }
    });
    self.EvaluationConflictsFromSelectedEvaluation = ko.observableArray([]);
    self.SelectEvaluationConflictRow = function (item) {
        self.SelectedEvaluationConflictRow(item);
        return true;
    };
    self.SelectedEvaluationConflictRow = ko.observable();
    self.SelectedEvaluationConflictRow.subscribe(function () {
        var enableButton = self.SelectedEvaluationConflictRow() != null;
        BaoMenu.permissionEnable({
            ActionKey: "SolveConflict",
            Enabled: enableButton,
            Context: tabPage.Context()
        });
    });
    BaoMenu.registerEvent(function (value) {
        if (tabPage.IsActiveTab()) {
            switch (value.ActionKey()) {
                case "SolveConflict":
                    self.SolveConflict();
                    break;
                case "EvaluationConflictRefresh":
                    self.Refresh();
                    break;
            }
        }
    });
    self.GetAllEvaluations = function () {
        return Bao.post("Checkware/EvaluationConflict/GetAllEvaluations", JSON.stringify({
            pageIndex: self.PageIndex(),
            pageSize: self.PageSize(),
            sorting: self.Sorting()
        }), function (searchResult) {
            self.SelectedEvaluationConflictRow(null);
            self.TotalRows(0);
            self.EvaluationCollection([]);
            self.EvaluationConflictsFromSelectedEvaluation([]);
            if (searchResult != null && searchResult.Models != null) {
                self.EvaluationCollection(searchResult.Models);
                self.TotalRows(searchResult.TotalRows);
            }
            tabPage.IsLoading(false);
        });
    };
    self.GetAllEvaluationConflictsFromEvaluation = function (evaluationId) {
        return Bao.post("Checkware/EvaluationConflict/GetAllEvaluationsConflictsToEvaluation", JSON.stringify({
            evaluationId: evaluationId,
            pageIndex: self.ConflictPageIndex(),
            pageSize: self.ConflictPageSize(),
            sorting: self.ConflictSorting()
        }), function (searchResult) {
            self.ConflictTotalRows(0);
            self.EvaluationConflictsFromSelectedEvaluation([]);
            if (searchResult != null && searchResult.Models != null) {
                self.EvaluationConflictsFromSelectedEvaluation(searchResult.Models);
                self.EvaluationConflictsFromSelectedEvaluation.unshift(ServerVersion);
                self.ConflictTotalRows(searchResult.ConflictTotalRows);
            }
            tabPage.IsLoading(false);
        });
    };
    self.SolveConflict = function () {
        var questionDialog = new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgEvaluationSolveConflict"), "yesno");
        questionDialog.DialogResult.subscribe(function (dialogResult) {
            if (dialogResult === true) {
                return Bao.post("Checkware/EvaluationConflict/SolveConflict", JSON.stringify({
                    evaluationId: self.SelectedEvaluationRow().EvaluationId,
                    evaluationConflictId: self.SelectedEvaluationConflictRow().EvaluationConflictId,
                    updateBy: self.SelectedEvaluationConflictRow().UpdateBy
                }), function (searchResult) {
                    self.EvaluationConflictsFromSelectedEvaluation([]);
                    self.SelectedEvaluationConflictRow();
                    self.SelectedEvaluationRow();
                    self.Refresh();
                    tabPage.IsLoading(false);
                });
            }
        });
    };
    self.Refresh = function () {
        tabPage.IsLoading(true);
        self.EvaluationCollection([]);
        self.EvaluationConflictsFromSelectedEvaluation([]);
        self.GetAllEvaluations();
        tabPage.IsLoading(false);
    };
    self.loaded = function () {
        self.Refresh();
    };
}
Bao.inherit(EvaluationConflict, BaseViewModel);
export default EvaluationConflict;